import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const StyledInput = styled.textarea`
    height: 100px;
    min-width: 100px;
    border-radius: 8px;
    outline: none;
    border: 1px solid ${(props) => props.theme.lightGrey40};
    padding: 8px 16px;
    font-size: ${theme.font.size16};
    transition: all 0.3s;
    flex: 1;
    background: ${(props) => props.theme.white} 0% 0% no-repeat padding-box !important;
    border: 1px solid ${(props) => props.theme.borderLightGreyLink40};
    

    &.error {
        border: 1px solid ${(props) => props.theme.red};
    }

    &:focus:not(.error):not(.disabled),
    &:hover:not(.error):not(.disabled)  {
        border: 1px solid ${(props) => props.theme.orange};
    }

    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${(props) => props.theme.grey};
        opacity: 1; /* Firefox */
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${(props) => props.theme.grey};
    }

    &::-ms-input-placeholder { /* Microsoft Edge */
        color: ${(props) => props.theme.grey};
    }
`;

export const ContainerInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    div {
        position: absolute;
        right: 11px;
        width: 10px;

        &.icon-container {
            display: flex;
            align-items: center;
            justify-content: center;
            width: auto;
        }
    }
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 8px 16px;
  background: ${(props) => props.theme.white} 0% 0% no-repeat padding-box !important;
  border: 1px solid ${(props) => props.theme.borderLightGreyLink40};
  border-radius: 8px;
  outline: none;
`;
